import Component from './choose-payment-data';

export default Component;
